/** @format */

import DateTimeDisplay from './DateTimeDisplay';

interface Props {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}
export const ShowCounter = ({ days, hours, minutes, seconds }: Props) => {
  return (
    <div className='show-counter'>
      <a className='countdown-link'>
        <DateTimeDisplay value={days} type={'Days'} isDanger={days <= 3} />
        <p>:</p>
        <DateTimeDisplay value={hours} type={'Hours'} isDanger={false} />
        <p>:</p>
        <DateTimeDisplay value={minutes} type={'Mins'} isDanger={false} />
        <p>:</p>
        <DateTimeDisplay value={seconds} type={'Seconds'} isDanger={false} />
      </a>
    </div>
  );
};
